import React, { useState } from 'react';
import './header.css';
import Button from '@mui/material/Button';
import LoginIcon from '@mui/icons-material/Login';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

function Header() {
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);

    return (
        <header className='headernavbare paddings'>
            <img src="/images/logo.png" width={120} alt="Logo" />
            
            <div className={`navbar ${isNavbarOpen ? 'Newnavbar' : ''}`}>
                <ul>
                    <CloseIcon id="closeIcon" onClick={() => setIsNavbarOpen(false)} />
                    <li><a href="#">Home</a></li>
                    <li><a href="#">About</a></li>
                    <li><a href="#">Services</a></li>
                    <li><a href="#">Blog</a></li>
                    <li><a href="#">Pricing</a></li>
                    <li><a href="#">Contact</a></li>
                </ul>
                <div className="buttonContainer">
                    <h1><span>2</span>List</h1>
                    <Button startIcon={<LoginIcon />} variant="contained" disableElevation>
                        Sign In
                    </Button>
                </div>
            </div>

            <MenuIcon id='menuIcon' onClick={() => setIsNavbarOpen(true)} />
        </header>
    );
}

export default Header;
